var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4.25H6C2.82436 4.25 0.25 6.82436 0.25 10V22.5C0.25 25.6756 2.82436 28.25 6 28.25H26C29.1756 28.25 31.75 25.6756 31.75 22.5V10C31.75 6.82436 29.1756 4.25 26 4.25ZM6 6.75H26C27.7949 6.75 29.25 8.20507 29.25 10V22.5C29.25 24.2949 27.7949 25.75 26 25.75H6C4.20507 25.75 2.75 24.2949 2.75 22.5V10C2.75 8.20507 4.20507 6.75 6 6.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5H30V12.5H2V10.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21.25C17 20.5596 17.5596 20 18.25 20L25.75 20C26.4404 20 27 20.5596 27 21.25C27 21.9404 26.4404 22.5 25.75 22.5L18.25 22.5C17.5596 22.5 17 21.9404 17 21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.fc1655422b1c5f1e19d7e271afb27549.svg";
export { ForwardRef as ReactComponent };